<template>
	<div class="tokyo_tm_news">
		<div class="tokyo_tm_title">
			<div class="title_flex">
				<div class="left">
					<span>Writing / TR</span>
					<h3>Latest Writings / TR</h3>
				</div>
			</div>
		</div>

		<ul class="tokyo_tm_news_inner">
			<li v-for="(article, aKey) in articles" :key="aKey">
				<a :href="`writing/tr/${article.attributes.slug}`">
					<div class="list_inner">
						<div class="image">
							<img
								:src="`${apiUrl}${article.attributes.image.data.attributes.formats.medium.url}`"
								alt="thumb"
							/>
							<div
								class="main"
								:style="{
									backgroundImage:
										'url(' +
										`${apiUrl}${article.attributes.image.data.attributes.formats.medium.url}` +
										')',
								}"
							></div>
						</div>
						<!-- End .image -->
						<div class="details">
							<div class="extra">
								<p class="date">
									By <a href="#">Abdullah Gürsoy</a
									><span>{{ article.attributes.publish_date }}</span>
								</p>
							</div>
							<!-- End meta info -->
							<h3 class="title">
								{{ article.attributes.title }}
							</h3>
							<div class="tokyo_tm_read_more">
								<a><span>Read More</span></a>
							</div>
						</div>
						<!-- End .details -->
					</div>
				</a>
				<!-- End second modal -->
			</li>
			<!-- End single blog -->
		</ul>
	</div>
</template>

<script>
import axios from "axios";

export default {
	components: {},
	data() {
		return {
			apiUrl: "https://gursoy.me/strapi",
			articles: [],
		};
	},
	mounted() {
		axios
			.get(
				`${this.apiUrl}/api/blog-trs?fields[0]=title&fields[1]=publish_date&fields[2]=slug&populate=image&sort=publish_date:desc`
			)
			.then((response) => {
				const { data } = response.data;
				this.articles = data;
			});
	},
	methods: {},
};
</script>

<style scoped>
.list_inner {
	border-radius: 0.75rem;
}

.image {
	border-top-left-radius: 0.75rem;
	border-top-right-radius: 0.75rem;
	height: 250px;
}
</style>
